import React, { useEffect, useState } from 'react';

import useHashParamFeatureFlag from 'lib/hooks/useHashParamFeatureFlag';
import { FacetCounts } from 'lib/AutolistAPI';
import ModelYearRangeFilter from './ModelYearRangeFilter';
import PriceRangeFilter from './PriceRangeFilter';
import MileageRangeFilter from './MileageRangeFilter';
import EngineFilter from './EngineFilter';
import TransmissionFilter from './TransmissionFilter';
import DriveTrainFilter from './DriveTrainFilter';
import MakeModelFilter from './MakeModelFilter';
import ConditionFilter from './ConditionFilter';
import LocationFilter from './LocationFilter';
import FeaturesTechnologyFilter from './FeaturesTechnologyFilter';
import BodyStylesFilter from './BodyStylesFilter';
import AdvancedFilter from './AdvancedFilter';
import TruckOptionsFilter from './TruckOptionsFilter';
import ColorsFilter from './ColorsFilter';
import CategoryFilter from './CategoryFilter';

import styles from './styles';
import SaveClearSearchButtons from './SaveClearSearchButtons';
import MultiMakeModelFilter from './MultiMakeModelFilter';
import { checkIfShouldShowTooltip } from './MultiMakeModelFilter/util';

export default function SearchFilter({
  hideOnMobile = false,
  facetCounts,
}: {
  hideOnMobile?: boolean;
  facetCounts?: FacetCounts;
}): JSX.Element {
  const multiMakeModelEnabled = useHashParamFeatureFlag('multiMakeModel');
  const [renderTooltip, setRenderTooltip] = useState(false);

  useEffect(() => {
    if (multiMakeModelEnabled) {
      checkIfShouldShowTooltip({ setRenderTooltip });
    }
  }, [multiMakeModelEnabled]);

  return (
    <div className="search-filters-container">
      <div className={`${hideOnMobile ? 'hide-on-mobile' : ''}`}>
        <SaveClearSearchButtons />
      </div>
      <div className="mobile-filter">
        <LocationFilter expanded />
      </div>
      {multiMakeModelEnabled ? (
        <>
          <MultiMakeModelFilter expanded index={0} />
          <MultiMakeModelFilter index={1} />
          <MultiMakeModelFilter index={2} renderTooltip={renderTooltip} />
        </>
      ) : (
        <MakeModelFilter expanded makeFacets={facetCounts?.make} modelFacets={facetCounts?.model} />
      )}
      <ModelYearRangeFilter expanded />
      <PriceRangeFilter expanded />
      <MileageRangeFilter expanded />
      <BodyStylesFilter
        doorCountFacets={facetCounts?.doorCount}
        bodyStyleFacets={facetCounts?.bodyStyle}
      />
      <EngineFilter
        cylinderFacets={facetCounts?.engineCylinders}
        fuelTypeFacets={facetCounts?.fuelType}
      />
      <TransmissionFilter transmissionFacets={facetCounts?.transmission} />
      <DriveTrainFilter driveTrainFacets={facetCounts?.driveline} />
      <FeaturesTechnologyFilter featuresTechnologyFacets={facetCounts?.features} />
      <ConditionFilter conditionFacets={facetCounts?.condition} />
      <ColorsFilter
        exteriorColorFacets={facetCounts?.exteriorColor}
        interiorColorFacets={facetCounts?.interiorColor}
      />
      <CategoryFilter categoryFacets={facetCounts?.category} />
      <TruckOptionsFilter
        cabinFacets={facetCounts?.cabin}
        bedFacets={facetCounts?.bed}
        rearWheelFacets={facetCounts?.rearWheel}
      />
      <AdvancedFilter />
      <style jsx>{styles}</style>
    </div>
  );
}
